import React, { FC } from 'react';
import * as classes from './Footer.module.scss';
import cn from 'classnames';
import { Trans, useTranslation } from 'gatsby-plugin-react-i18next';
import { ANY_STRING } from '../../../../../constants/constants';
import Link from '../../../../Common/Link/Link';
import SocialIconsWrapper from '../SocialIconsWrapper/SocialIconsWrapper';
import SocialIcons from '../../../../Common/SocialIcons/SocialIcons';
import { TemplatesList } from '../../../../../enums/TemplatesList';
import TriangleBlock from '../TriangleBlock/TriangleBlock';
import { FooterProps } from '../../../DefaultTemplate/Components/Footer/Footer';

const Footer: FC<FooterProps> = ({
  addresses,
  sectorsList,
  languages,
  shortName,
  phoneNumber,
  euVatNumber,
  email,
  officialId,
  socialLinks,
}) => {
  const { t } = useTranslation();
  return (
    <footer className={classes.wrapper}>
      <div className={classes.leftBlock}>
        <div>
          <div className={classes.title}>{shortName}</div>
          <div className={classes.sectors}>{sectorsList.join(' • ')}</div>
          <div>{euVatNumber}</div>
          <div>{officialId}</div>
        </div>
        <div className={classes.copyRightsWrapper}>
          <div className={classes.copy}>
            {`© ${new Date().getFullYear()}`}, {shortName}
          </div>
          <div>
            <Trans i18nKey={'subFooter.subFooterDescription'}>
              {ANY_STRING}
              <a className={classes.link} href={'mailto:support@webfolio.com'} rel={'noreferrer'} target={'_blank'}>
                {ANY_STRING}
              </a>
              {ANY_STRING}
            </Trans>
          </div>
        </div>
      </div>
      <div className={classes.rightBlock}>
        <div className='row'>
          <div className={cn('col-12 col-sm-6', classes.infoWrapper)}>
            <div className={classes.title}>{t('footer.location')}</div>
            {addresses.map((item, index) => (
              <div key={index} className={classes.address}>
                {item}
              </div>
            ))}
          </div>
          <div className={cn('col-12 col-sm-6', classes.infoWrapper)}>
            <div className={classes.title}>{t('footer.contact')}</div>
            <div>
              <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
            </div>
            <div>
              <a href={`mailto:${email}`}>{email}</a>
            </div>
          </div>
          <div className={cn('col-12 col-sm-6', classes.infoWrapper)}>
            <div className={classes.title}>{t('footer.languages')}</div>
            <div>{languages.join(', ')}</div>
          </div>
        </div>
        <div className={classes.aboutWebfolio}>
          <Trans i18nKey={'footer.webfolioDescription'}>
            {ANY_STRING}
            <Link isExternalLink isTargetBlank path={t('footer.webfolioDescriptionLink')}>
              {ANY_STRING}
            </Link>
            {ANY_STRING}
          </Trans>
        </div>
      </div>
      {!!socialLinks.length && (
        <SocialIconsWrapper>
          <SocialIcons template={TemplatesList.MODERN} items={socialLinks} />
        </SocialIconsWrapper>
      )}
      <TriangleBlock className={classes.bigTriangle} />
      <TriangleBlock className={classes.smallTriangle} />
    </footer>
  );
};

export default Footer;
